// extracted by mini-css-extract-plugin
module.exports = {"container":"LinkByEnvironment_container__AXIts"};